/* eslint-disable functional/prefer-readonly-type */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable functional/immutable-data */
import { useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import CrudIndex from '~/components/CrudIndex'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'

export default function Index() {
  const { translate } = useLang()

  const forceRefresh = useHookstate(false)
  const name = useHookstate<string | null>(null)
  const agencyId = useHookstate<number | null>(null)
  const deviceTypeId = useHookstate<number | null>(null)
  const inspectionItemId = useHookstate<number | null>(null)

  useEffect(() => {
    document.title = translate('Resources - Dispatch System')
  }, [])

  const inspectionConfigFilter = [
    {
      name: 'agency_id',
      type: 'agency_id',
      placeholder: translate('Agency:name'),
      variable: agencyId,
    },
    {
      name: 'device_type_id',
      type: 'device_type_id',
      placeholder: translate('Device Type'),
      variable: deviceTypeId,
    },
    {
      name: 'inspection_item_id',
      type: 'inspection_item_id',
      placeholder: translate('Inspection Item'),
      variable: inspectionItemId,
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model="inspection-config"
        title={translate('Inspection Configuration')}
        disableColumnsFilters
        viewTitle={translate('Inspection Configuration')}
        canView={true}
        showInViewMore={[
          'inspection_item:name',
          'agency:name',
          'device_type:name',
          'required',
          'created_at',
        ]}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        filters={inspectionConfigFilter}
        clearFilters={() => {
          name.set('')
          agencyId.set(null)
          deviceTypeId.set(null)
          inspectionItemId.set(null)
          forceRefresh.set(!forceRefresh.get())
        }}
        notSortable={[]}
        forceOrderColumns={[
          'inspection_item:name',
          'agency:name',
          'device_type:name',
          'required',
        ]}
        exceptColumns={['deleted_at', 'updated_at']}
        cellLabel={[
          {
            field: 'required',
            value: { 0: translate('No'), 1: translate('Yes') },
          },
        ]}
      />
    </Layout>
  )
}
